/**
 * Token gerektiren API çağrıları için fetch sarmalayıcısı.
 * 401 (Invalid or expired token) dönerse oturumu temizleyip giriş sayfasına yönlendirir.
 */
export const redirectToLogin = () => {
  localStorage.removeItem('user');
  if (window.location.pathname !== '/') {
    window.location.href = '/';
  }
};

const authFetch = async (input, init = {}) => {
  const response = await fetch(input, init);

  if (response.status === 401) {
    redirectToLogin();
    // Yönlendirme sırasında çağıran kodun devam etmemesi için hata fırlat
    throw new Error('Oturum süresi doldu, giriş sayfasına yönlendiriliyorsunuz...');
  }

  return response;
};

export default authFetch;
